import React from 'react';
import { Box, Divider, Stack, Typography } from '@mui/material';
import SectionCard from './SectionCard';

export default function FormSection({
  title,
  description,
  actions,
  children,
  tone = 'dashboard',
  sx,
  contentSx,
}) {
  return (
    <SectionCard
      tone={tone}
      sx={sx}
      disablePadding
      contentSx={contentSx}
      title={
        <Stack spacing={0.3}>
          <Typography variant="subtitle1" sx={{ fontWeight: 800 }}>
            {title}
          </Typography>
          {description ? (
            <Typography variant="caption" color="text.secondary">
              {description}
            </Typography>
          ) : null}
        </Stack>
      }
      action={actions}
    >
      <Divider />
      <Box sx={{ p: { xs: 1.5, sm: 2 } }}>{children}</Box>
    </SectionCard>
  );
}

